import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/button';

const amenitiesImages = [
  { src: '/media/sun_city_interior_garden_view.webp', label: 'OUT IN THE NATURE', tag: 'Artistic Impression' },
  { src: '/media/sun_city_amenities2.webp', label: 'KIDS PLAY AREA', tag: 'Artistic Impression' },
  { src: '/media/sun_city_hero3.webp', label: 'CLUB ATLANTIS', tag: 'Artistic Impression' },
  { src: '/media/sun_city_amenities1.webp', label: 'COURT', tag: 'Artistic Impression' },
  { src: '/media/sun_city_walking_area.webp', label: 'WALKING AREA', tag: 'Artistic Impression' },
  { src: '/media/sun_city_interior_corridor.webp', label: 'LUXURIOUS LIVING', tag: 'Artistic Impression' },
];

export default function Amenities({ onEnquireClick }) {
  return (
    <section
      id="amenities"
      data-testid="amenities-section"
      className="py-10 sm:py-12 md:py-16 bg-white lg:mr-72 xl:mr-80"
    >
      <div className="max-w-5xl mx-auto px-4">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8 sm:mb-10"
        >
          <h2 className="font-serif text-xl sm:text-2xl md:text-3xl text-[#9A7B4F] mb-2">
            Sai Sun City - Luxurious Amenities
          </h2>
          <div className="w-12 sm:w-16 h-1 bg-[#9A7B4F] mx-auto" />
        </motion.div>

        {/* Amenities Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4">
          {amenitiesImages.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              className="relative group overflow-hidden"
            >
              <img
                src={item.src}
                alt={item.label}
                className="w-full h-36 sm:h-44 md:h-56 object-cover transition-transform duration-500 group-hover:scale-110"
              />
              {/* Label Overlay */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-2 sm:p-3">
                <p className="text-white font-semibold text-xs sm:text-sm">{item.label}</p>
                <p className="text-white/60 text-[10px] sm:text-xs">{item.tag}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center mt-8 sm:mt-10">
          <Button
            onClick={onEnquireClick}
            className="bg-[#9A7B4F] hover:bg-[#8A6B3F] text-white rounded-none px-6 sm:px-8 py-4 sm:py-5 font-semibold text-xs sm:text-sm"
          >
            Request All Amenities
          </Button>
        </div>
      </div>
    </section>
  );
}
